import { BaseTool } from '../BaseTool';
import * as THREE from 'three';
import { ThreeEvent } from '@react-three/fiber';

export class MeasureTool extends BaseTool {
    id = 'MANAGE_MEASURE';
    name = 'Measure';
    cursor = 'crosshair';

    private startPoint: THREE.Vector3 | null = null;
    private currentPoint: THREE.Vector3 | null = null;

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;
        const snapped = this.snapToGrid(point);

        if (!this.startPoint) {
            this.startPoint = snapped;
            this.currentPoint = snapped;
            this.updatePreview();
        } else {
            // Finish measurement
            const dist = this.startPoint.distanceTo(snapped);
            const formatted = `${dist.toFixed(4)} meters`;
            console.log(`Measured Distance: ${formatted}`);
            window.dispatchEvent(
                new CustomEvent('yap:notify', {
                    detail: { message: `Measured distance: ${dist.toFixed(3)} m` },
                })
            );

            this.startPoint = null;
            this.currentPoint = null;
            this.context.appStore.setToolPreview(null);
            this.context.appStore.setActiveTool('select');
        }
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context || !this.startPoint) return;
        const point = this.getIntersection(event);
        if (point) {
            this.currentPoint = this.snapToGrid(point);
            this.updatePreview();
        }
    }

    private updatePreview() {
        if (!this.context || !this.startPoint || !this.currentPoint) return;

        const dist = this.startPoint.distanceTo(this.currentPoint);

        this.context.appStore.setToolPreview({
            type: 'measure',
            start: this.startPoint,
            end: this.currentPoint,
            value: `${dist.toFixed(3)}m`
        });
    }

    onPointerUp(): void { }
}
